'use client';

import React, { memo } from 'react';

type BulletType = 'positive' | 'negative' | 'neutral' | 'gray';

interface StatusBulletProps {
  type?: BulletType;
}

const bulletStyles: Record<BulletType, string> = {
  positive: 'text-green-400 bg-green-400/10',
  negative: 'text-rose-400 bg-rose-400/10',
  neutral: 'text-blue-400 bg-blue-400/10',
  gray: 'text-gray-500 bg-gray-100/10 dark:bg-gray-500/10',
};

const StatusBullet = memo(function StatusBullet({ type = 'neutral' }: StatusBulletProps) {
  return (
    <div className={`mt-0.5 flex-none rounded-full p-1 ${bulletStyles[type]}`}>
      <div className="size-1 rounded-full bg-current" />
    </div>
  );
});

export default StatusBullet;
